require('es6-promise').polyfill();
require('isomorphic-fetch');

const makeRequest = (method, apiRoute, body) => {
  const fullUrl = `https://${window.localStorage.tss_url}/${apiRoute}`;

  const authToken = window.localStorage.token;
  const commonOpts = {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`
    },
  };

  const opts = body ?
    Object.assign(commonOpts, { body: JSON.stringify(body) }) :
    commonOpts;

  return fetch(fullUrl, opts)
    .then(response => response.json().then(json => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok) {
        const { status } = response;
        const error = {
          ...json,
          status,
        };
        if (status === 401) {
          delete window.localStorage.token;
          // location.reload();
        }
        return Promise.reject(error);
      }

      return json;
    });
};

export const post = (apiRoute, body) => makeRequest('POST', apiRoute, body);
export const get = (apiRoute) => makeRequest('GET', apiRoute);
export const remove = (apiRoute) => makeRequest('DELETE', apiRoute);
export const update = (apiRoute, body) => makeRequest('PUT', apiRoute, body);


// WEBPACK FOOTER //
// ./src/libs/apiMethods.js